import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

const axios = AxiosConfigExplore();

export const createFavoriteItem = async ({ itemId, itemType }) => {
  try {
    const url = "/user/favorite-item/create";
    const res = await axios.post(url, {
      item_id: itemId,
      item_type: itemType,
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFavoriteFaculty = async ({
  page = 0,
  rowsPerPage = 1000,
} = {}) => {
  try {
    const url = `/user/favorite-item/get/faculty?page=${page}&rowsPerPage=${rowsPerPage}`;
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFavoriteInstitution = async ({
  page = 0,
  rowsPerPage = 1000,
} = {}) => {
  try {
    const url = `/user/favorite-item/get/institution?page=${page}&rowsPerPage=${rowsPerPage}`;
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFavoriteUnit = async ({ page = 0, rowsPerPage = 1000 } = {}) => {
  try {
    const url = `/user/favorite-item/get/unit?page=${page}&rowsPerPage=${rowsPerPage}`;
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFavoriteVenue = async ({ page = 0, rowsPerPage = 1000 } = {}) => {
  try {
    const url = `/user/favorite-item/get/venue?page=${page}&rowsPerPage=${rowsPerPage}`;
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getFavoriteConcept = async ({
  page = 0,
  rowsPerPage = 1000,
} = {}) => {
  const url = `/user/favorite-item/get/concept?page=${page}&rowsPerPage=${rowsPerPage}`;
  const res = await axios.get(url);
  return res.data;
};

export const deleteFavoriteItem = async ({ itemId }) => {
  const url = "/user/favorite-item/delete";
  const res = await axios.delete(url, {
    data: {
      item_id: itemId,
    },
  });
  return res.data;
};
